import api from "../api";

const propertyLiabilityService = {
  // Get property liabilities edit data
  getEditData: async (propertyId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/liabilities/edit`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching liability edit data:", error);
      throw error;
    }
  },

  // Update property liabilities
  update: async (propertyId, data) => {
    try {
      const response = await api.put(
        `/properties/${propertyId}/liabilities`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error updating liability:", error);
      throw error;
    }
  },

  // Get liability types
  getTypes: async () => {
    try {
      const response = await api.get("/property-liabilities/types");
      return response.data;
    } catch (error) {
      console.error("Error fetching liability types:", error);
      throw error;
    }
  },

  // Get liability options
  getOptions: async () => {
    try {
      const response = await api.get("/property-liabilities/options");
      return response.data;
    } catch (error) {
      console.error("Error fetching liability options:", error);
      throw error;
    }
  },
};

export default propertyLiabilityService;
